export const calculateRecommendedPrice = (priceObject: GQL.IPrice) => {
  // typ slevy
  const discountType = priceObject.discountPercent !== null && priceObject.discountPercent > 0
    ? 'discountPercent'
    : 'discount';

  if (priceObject && priceObject.priceWithout) {
    let recommendedPriceWithout = priceObject.recommendedPriceWithout;

    // sleva v částce
    if (discountType === 'discount') {
      recommendedPriceWithout = (priceObject.priceWithout || 0) + (priceObject.discount || 0);
    }

    // sleva v procentech
    if (discountType === 'discountPercent') {
      recommendedPriceWithout = ((priceObject.priceWithout || 0) / (100 - (priceObject.discountPercent || 0))) * 100;
    }

    // zaokrouhlení ceny
    return Math.round((recommendedPriceWithout || 0) * 100) / 100;
  }

  return null;
}


// WEBPACK FOOTER //
// ./src/helpers/Prices/calculateRecommendedPrice.ts